module.exports = __webpack_public_path__ + "img/PC_04.bc196443.jpg";